module.exports = __webpack_public_path__ + "static/assets/2a86f9f0a1d7f9606d1f8610e0a9db15.png";